import {FiBattery,FiActivity,FiTrendingUp,FiZap,FiTarget,FiShield} from 'react-icons/fi';

export const PROTOCOLS=[
  {id: '12-12',label: '12:12',hours: 12,description: 'Beginner / Circadian Rhythm',difficulty: 'Easy',color: 'text-blue-500'},
  {id: '14-10',label: '14:10',hours: 14,description: 'Digestive Rest',difficulty: 'Easy',color: 'text-cyan-500'},
  {id: '16-8',label: '16:8',hours: 16,description: 'Popular / Fat Loss',difficulty: 'Medium',color: 'text-emerald-500'},
  {id: '18-6',label: '18:6',hours: 18,description: 'Advanced Fat Burning',difficulty: 'Hard',color: 'text-indigo-500'},
  {id: '20-4',label: '20:4',hours: 20,description: 'Warrior Diet',difficulty: 'Hard',color: 'text-orange-500'},
  {id: 'omad',label: 'OMAD',hours: 23,description: 'One Meal A Day',difficulty: 'Expert',color: 'text-rose-500'},
  {id: '48h',label: '48H',hours: 48,description: 'Extended Fast',difficulty: 'Expert',color: 'text-purple-500'},
  {id: '72h',label: '72H',hours: 72,description: 'Deep Autophagy',difficulty: 'Master',color: 'text-pink-500'},
];

export const PHASES=[
  {start: 0,end: 4,title: 'Digestion Phase',desc: 'Your digestive system is working hard to break down your last meal into glucose.',bodyDetails: [
    'Blood sugar levels peak as nutrients enter the bloodstream.',
    'Insulin is released to transport glucose into your cells.',
    'Energy is stored as glycogen in the liver and muscles.'
  ],icon: FiBattery,image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800'},
  {start: 4,end: 12,title: 'Post-Absorptive',desc: 'Your body moves from external fuel to its own internal energy stores.',bodyDetails: [
    'Insulin levels begin a steady decline.',
    'The liver starts releasing stored glycogen to maintain glucose levels.',
    'Digestive organs enter a resting state for repair.'
  ],icon: FiActivity,image: 'https://images.unsplash.com/photo-1505576399279-565b52d4ac71?auto=format&fit=crop&q=80&w=800'},
  {start: 12,end: 16,title: 'Fat Burning Zone',desc: 'Glycogen stores are running low. Your body switches to burning stored fat.',bodyDetails: [
    'Lipolysis increases: fat cells release fatty acids into the blood.',
    'Glucagon rises to facilitate fat mobilization.',
    'Growth hormone increases,helping to preserve muscle mass.'
  ],icon: FiTrendingUp,image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80&w=800'},
  {start: 16,end: 18,title: 'Ketogenesis',desc: 'The liver begins converting fatty acids into ketones for brain fuel.',bodyDetails: [
    'Ketones provide a stable,efficient energy source for neurons.',
    'Mental clarity and focus often peak during this stage.',
    'Inflammation markers begin to decrease throughout the body.'
  ],icon: FiZap,image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=800'},
  {start: 18,end: 24,title: 'Autophagy Activation',desc: 'The "self-cleaning" process where cells recycle damaged components.',bodyDetails: [
    'Cells begin removing old proteins and damaged mitochondria.',
    'Enhanced DNA repair and immune system rejuvenation.',
    'Autophagy helps protect against cellular aging and disease.'
  ],icon: FiTarget,image: 'https://images.unsplash.com/photo-1507413245164-6160d8298b31?auto=format&fit=crop&q=80&w=800'},
  {start: 24,end: 48,title: 'Deep Ketosis',desc: 'Maximum ketone production and metabolic efficiency.',bodyDetails: [
    'Ketone levels reach therapeutic ranges for brain health.',
    'Autophagy intensifies throughout all body tissues.',
    'Growth hormone peaks,protecting lean muscle mass.',
    'Inflammation markers drop significantly.'
  ],icon: FiShield,image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&q=80&w=800'},
  {start: 48,end: 72,title: 'Stem Cell Activation',desc: 'Your body begins regenerating immune cells and tissues.',bodyDetails: [
    'Immune system regeneration accelerates.',
    'Stem cell production increases dramatically.',
    'Old immune cells are recycled and replaced.',
    'Maximum autophagy and cellular renewal.'
  ],icon: FiZap,image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=800'},
  {start: 72,end: 999,title: 'Peak Transformation',desc: 'Extended metabolic reset with profound healing benefits.',bodyDetails: [
    'Complete metabolic switching to fat-based energy.',
    'Maximum cellular cleanup and regeneration.',
    'Enhanced longevity pathways activated.',
    'Profound mental clarity and focus.'
  ],icon: FiTarget,image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800'}
];

export const MOTIVATION_QUOTES=[
  "Your body is healing itself right now.",
  "Discipline is the bridge to your goals.",
  "You are building metabolic flexibility.",
  "Every hour is a victory for your health.",
  "Hunger is a sign of your body changing.",
  "Your future self is thanking you.",
  "Focus on the feeling of being light.",
  "Healing happens in the silence of the gut.",
  "Strength grows in the moments you want to quit.",
  "Your cells are renewing as you fast.",
  "This is your body learning to burn clean fuel.",
  "You're not starving,you're thriving.",
  "Autophagy is the ultimate self-care.",
  "Every passing hour makes you stronger.",
  "Your mitochondria are celebrating right now.",
  "Fasting is the ultimate reset button.",
  "You're building a body that runs on fat,not fear.",
  "Mental clarity is just hours away.",
  "Your ancestors fasted for survival. You fast for excellence.",
  "This temporary discomfort is permanent transformation.",
  "You're rewiring your metabolism right now.",
  "Ketones are your brain's premium fuel.",
  "Your insulin is finally taking a break.",
  "This is how champions are built—one hour at a time.",
  "You're not missing out,you're leveling up."
];

export const TRASH_TALK_QUOTES=[
  "Is that your stomach growling or your willpower dying?",
  "A toddler has more discipline than you right now.",
  "The fridge isn't running away. Calm down.",
  "Water is a meal for champions. Drink it and shut up.",
  "You're not hungry,you're just bored. Get a hobby.",
  "Imagine being defeated by a slice of bread. Pathetic.",
  "Your ancestors hunted mammoths. You're crying over a snack.",
  "Don't trade your progress for a 5-minute dopamine hit.",
  "That craving? It's just a test. And you're failing.",
  "Your stomach is growling? Good. That's the sound of fat burning.",
  "Weak people eat when they're bored. Be better.",
  "You really gonna quit because of a little hunger?",
  "Your body is literally eating itself clean and you want a cookie?",
  "Stop thinking about food and start thinking about results.",
  "If you can't control your cravings,what CAN you control?",
  "That snack will taste good for 2 minutes. Regret lasts all day.",
  "Your excuses are weaker than your willpower.",
  "Every time you resist,you win. Every time you cave,you lose.",
  "The only thing standing between you and your goals is a sandwich.",
  "You've already come this far. Don't be a quitter now.",
  "Hunger is temporary. Screenshots of your progress are forever.",
  "If it was easy,everyone would look like you want to look.",
  "Stop negotiating with yourself. You already committed.",
  "Your future self is watching. Make them proud.",
  "The only failure is giving up before the timer ends."
];

export const DONT_QUIT_MESSAGES=[
  "Don't quit now. You're stronger than you think.",
  "Quitting is not an option. Keep going.",
  "Winners never quit. Quitters never win.",
  "The pain you feel today is the strength you feel tomorrow.",
  "Your only limit is you. Don't stop.",
  "Every champion was once a contender that refused to give up.",
  "Success is what comes after you stop making excuses.",
  "The body achieves what the mind believes.",
  "Don't wish for it. Work for it.",
  "Fall seven times,stand up eight.",
  "The harder the battle,the sweeter the victory.",
  "Doubt kills more dreams than failure ever will.",
  "You didn't come this far to only come this far.",
  "Prove them wrong. Prove yourself right.",
  "Great things never come from comfort zones.",
  "The difference between try and triumph is a little umph.",
  "Excuses don't burn calories.",
  "You're not going to master the rest of your life in one day.",
  "Small progress is still progress.",
  "Believe you can and you're halfway there.",
  "Your limitation—it's only your imagination.",
  "Sometimes later becomes never. Do it now.",
  "The secret of getting ahead is getting started.",
  "It's going to be hard,but hard does not mean impossible.",
  "Don't stop when you're tired. Stop when you're done.",
  "Wake up with determination. Go to bed with satisfaction.",
  "Do something today that your future self will thank you for.",
  "Little things make big days.",
  "It's a slow process,but quitting won't speed it up.",
  "Success doesn't just find you. You have to go out and get it."
];

export const BADGES=[
  {id: 'first-16',label: 'First 16h',icon: '🏅',reqHours: 16},
  {id: 'warrior',label: '24h Warrior',icon: '⚔️',reqHours: 24},
  {id: '48h-hero',label: '48h Hero',icon: '🦸',reqHours: 48},
  {id: '72h-master',label: '72h Master',icon: '👑',reqHours: 72},
  {id: 'streak-3',label: '3 Day Streak',icon: '🔥',reqStreak: 3},
  {id: 'streak-7',label: '7 Day Streak',icon: '🚀',reqStreak: 7},
];